import { useQuery, useMutation } from '@tanstack/react-query';

import Axios from 'axios';
import { queryClient } from 'QueryClientProvider';

const onGetPackagePlaylistByID = (ID) => {
    if (ID === null) return null;
    return Axios.get(`/packageplaylists/${ID}`);
};

const usePackagePlaylist = (ID) => {
    return useQuery({
        queryKey: ['package-playlist', ID],
        queryFn: () => onGetPackagePlaylistByID(ID),
        staleTime: 10000,
        cacheTime: 10000,
        retry: false,
        enabled: ID ? true : false,
    });
};

const forceReloadPackagePlaylist = (ID) => {
    queryClient.invalidateQueries({ queryKey: ['package-playlist', ID] });
};

const editPackagePlaylistDocuments = ({ playlist }) => Axios.put('/packageplaylists/Documents', playlist);

const useEditPackagePlaylistDocuments = () => {
    return useMutation({
        mutationFn: editPackagePlaylistDocuments,
    });
};

const editPackagePlaylist = ({ playlist }) => Axios.put('/packageplaylists', playlist);

const useEditPackagePlaylist = () => {
    return useMutation({
        mutationFn: editPackagePlaylist,
    });
};

export {
    usePackagePlaylist,
    useEditPackagePlaylistDocuments,
    useEditPackagePlaylist,
    forceReloadPackagePlaylist,
};
